import {
    respondToBelow,
    ScreenWidth,
} from '@superbet-group/web.lib.vue-utilities';

export function isMobileEventView() {
    return respondToBelow(ScreenWidth.dXs);
}
